import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
import { attachGATracking } from "./helpers/tracking";

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if(process.env.NODE_ENV === "production") {
    attachGATracking(process.env.REACT_APP_NAME, process.env.REACT_APP_GA_ID);
}
